"use client";

import { track } from "@/lib/analytics";

interface OutboundLinkProps
  extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  toolId: number;
  children: React.ReactNode;
}

export default function OutboundLink({
  toolId,
  children,
  ...props
}: OutboundLinkProps) {
  const handleClick = () => {
    // GA4 conversion: user clicked through to the external tool.
    track("tool_outbound_click", { tool_id: toolId, url: props.href });

    // Fire-and-forget upvote
    fetch("/api/vote", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ toolId }),
      keepalive: true,
    }).catch(() => {});
  };

  return (
    <a onClick={handleClick} {...props}>
      {children}
    </a>
  );
}
